import "./FriendActionModal.css";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setSelectedFriend,
  toggleFriendActionModal,
  setShowBlockPopup,
  setShowReportPopup,
} from "../../redux/slicers/friendModalSlicer";

import { useTranslation } from "react-i18next";
import BottomSheet from "../card/PostCard/BottomSheet";
import * as profileApi from "../../api/requests/profile";
import { IonActionSheet } from "@ionic/react";
import {
  closeOutline,
  eyeOffOutline,
  flagOutline,
  trashOutline,
} from "ionicons/icons";

const FriendActionModal = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { friendActionModal, selectedFriend } = useSelector(
    (state) => state.friendModal,
  );

  const currentUser = useSelector((state) => state.currentProfile.data);
  const isAdmin = currentUser?.isAdmin || false;

  if (!friendActionModal || !selectedFriend) return null;

  const handleClose = () => {
    dispatch(toggleFriendActionModal());
  };

  const handleDeleteUser = async () => {
    if (
      !window.confirm(
        `Are you sure you want to delete user @${selectedFriend.username}? This action cannot be undone.`,
      )
    ) {
      return;
    }

    setLoading(true);
    try {
      const response = await profileApi.deleteUser(selectedFriend.username);
      if (response.status === 200) {
        alert(
          `User @${selectedFriend.username} has been deleted successfully.`,
        );
        dispatch(toggleFriendActionModal());
        window.location.reload(); // Reload the page
      } else {
        alert(response.data?.errors?.[0]?.msg || "Failed to delete user");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("An error occurred while deleting the user");
    } finally {
      setLoading(false);
    }
  };

  const buttons = [];
  if (isAdmin) {
    buttons.push({
      text: t("delete"),
      role: "destructive",
      icon: trashOutline,
      handler: handleDeleteUser,
    });
  }
  buttons.push(
    {
      text: t("mute"),
      icon: eyeOffOutline,
      handler: () => dispatch(setShowBlockPopup(true)),
    },
    {
      text: t("report"),
      icon: flagOutline,
      handler: () => dispatch(setShowReportPopup(true)),
    },
    {
      text: t("cancel"),
      icon: closeOutline,
      role: "cancel",
    },
  );
  return (
    <IonActionSheet
      isOpen={friendActionModal}
      onDidDismiss={handleClose}
      trigger="open-action-sheet"
      header={`@${selectedFriend.username}`}
      buttons={buttons}
    >
      {/* <div className="post-delete-modal__wrapper">
        <div className="post-delete-modal__text">
          <p>@{selectedFriend.username}</p>
        </div>
        <hr className="post-delete-modal__divider" />
        <div className="post-delete-modal__btns display-flex flex-direction-c">
          <button
            // className="follow-btn"
            onClick={() => dispatch(setShowBlockPopup(true))}
            disabled={loading}
          >
            {t("mute")}
          </button>
          <button
            // className="follow-btn"
            onClick={() => dispatch(setShowReportPopup(true))}
            disabled={loading}
          >
            {t("report")}
          </button>
          {isAdmin && (
            <button
              // className="follow-btn"
              onClick={handleDeleteUser}
              disabled={loading}
            >
              {loading ? "Deleting..." : "Delete User"}
            </button>
          )}
          <button className="cancel" onClick={handleClose}>
            {t("cancel")}
          </button>
        </div>
      </div> */}
    </IonActionSheet>
  );
};

export default FriendActionModal;
